<template>
  <v-dialog v-model="add" persistent max-width="370" class="mx-1">
    <v-btn dark color="red lighten-1" small slot="activator">
      <v-icon>add</v-icon> <pre>@SHKID_bot в Telegram</pre>
    </v-btn>
    <v-card>
      <v-toolbar flat>
        <span>Telegram-bot</span>
        <v-spacer></v-spacer>
        <v-btn flat icon @click.native="clearData()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-text-field
          label="Введите номер телефона в формате 7xxxxxxxxx"
          v-model="newphone"
        ></v-text-field>
        <v-checkbox v-model="acceptOfert">
          <template v-slot:label>
            <div>
              <small>Условия <a
                target="_blank"
                href="https://cds43.ru/storage/documents/1761039793_oferta.pdf"
              >
                договора-оферты
              </a> прочитал(а) и принимаю</small>
            </div>
          </template>
        </v-checkbox>
        <v-checkbox v-model="acceptInstruction">
          <template v-slot:label>
            <div>
              <small>С <a
                target="_blank"
                href="/docs/Shkid_bot_telegram.pdf"
              >
                инструкцией
              </a> по подключению ознакомлен(а)</small>
            </div>
          </template>
        </v-checkbox>
        <small>
          <b>После нажатия кнопки "Продолжить" диалог будет закрыт. Чат-бот вы можете найти, введя @SHKID_Bot в поиске телеграма</b>
        </small>
        <br>
        <small v-if="destination">
          Номер телефона уже подключен
        </small>
        <br>
        <small v-if="amount && !destination">
          Сумма к списанию: <strong style="color:red">{{ parseFloat(amount /100) }}</strong> руб. (за календарный день)
        </small>
        <br>
        <small v-if="amount && !destination && parseFloat(amount / 100) > parseFloat(profile.balance)">
          Недостаточно средств. Ваш баланс: <strong style="color:blue">{{ profile.balance }}</strong> руб.
        </small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat
          @click.native="clearData"
        >
          Отмена
        </v-btn>
        <v-btn color="primary" flat
          @click.native="addPhone"
          :disabled="!validPhone || denied || destination !== null || !acceptOfert || !acceptInstruction"
        >
          <span>Продолжить</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// eslint-disable-next-line
import moment from 'moment'
const phoneRe = /^7\d{10}$/g
export default {
  name: 'new-telegram-dialog',
  props: ['profile'],
  data: () => ({
    destination: null,
    add: false,
    newphone: null,
    amount: null,
    tariff: null,
    denied: false,
    acceptOfert: false,
    acceptInstruction: false
  }),
  methods: {
    async fetch () {
        const { destinations } = await this.$store.dispatch('sioRequest', {
          topic: 'destinations',
          pl: {}
        })
        const destination = destinations.filter(x => x.transport === 'telegram' &&
        x.personid === this.profile.personid && x.address === this.newphoneTrimmed)[0]
        destination ? this.destination = destination : this.destination = null
        await this.fetchTariffs()
    },
    clearData () {
      this.add = false
      this.newphone = null
      this.destination = null
      this.amount = null
      this.denied = false
      this.acceptOfert = false
      this.acceptInstruction = false
    },
    async fetchTariffs () {
      const { tariffs } = await this.$store.dispatch('sioRequest', {
        topic: 'fetch-tariffs',
        pl: {}
      })
      this.tariff = tariffs.filter(x => x.tariffid === this.profile.tariffid)[0]
    },
    async addPhone () {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'telegram-create-request',
          pl: {
            phone: this.newphoneTrimmed,
            amount: this.amount * (-1),
          }
        })
        this.$emit('added')
        this.add = false
        this.newphone = null
        this.destination = null
        this.amount = null
        this.denied = false
        this.$store.dispatch('snack', meta.msg)
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async calculateAmount () {
      this.amount = parseInt(Math.abs(this.tariff.costs.misc.telegram))
      parseFloat(this.amount/100).toFixed(2) > parseFloat(this.profile.balance) ? this.denied = true : this.denied = false
    }
  },
  computed: {
    validPhone () {
      return phoneRe.test(String(this.newphoneTrimmed).toLowerCase())
    },
    today () {
      return moment().format('YYYY-MM-DD')
    },
    newphoneTrimmed () {
      if (!this.newphone) return
      return this.newphone.split(/\D/).join('').replace(/^8/, 7)
    }
  },
  watch: {
    async validPhone (val) {
      if (val === true) {
        await this.fetch()
        this.calculateAmount()
      }
    }
  }
}
</script>

<style lang="css">
</style>
